// extracted by mini-css-extract-plugin
export const root = "text-image-module--root--27MOD";
export const switchPos = "text-image-module--switchPos--3lqSu";
export const image = "text-image-module--image--1p6Jp";
export const caption = "text-image-module--caption--3FsBZ";
export const text = "text-image-module--text--1Q2eV";
export const center = "text-image-module--center--1dpyS";
export const left = "text-image-module--left--8Qzda";